export default __webpack_public_path__ + "static/media/14709-marcel.5275020b.pdf";